import { IModule } from './types';

export const ServiceClient: IModule = {
    name: 'serviceClient',
    route: 'service-clients',
};
